import urlFor from '@shared/sanity/image/urlFor';
import { isCurrentlyWithinDateRangeUTC } from '@shared/v2/utils/date';

import {
  PrimaryDefault,
  PrimaryPromo,
} from '@/v2/services/sanity/types/api/response/homepageHero';

/*
    Do not change this without talking to design.
    Not just resizing for perf reasons - styles have been set to work with this exact size.
*/
const HERO_IMAGE_WIDTH = 870;

const getPrimaryPromoData = (primaryPromo: PrimaryPromo) => {
  const { callToAction, content, duration, image, headline, tagline, sash } =
    primaryPromo;
  const { variation, price, priceOverline, priceSubtext, priceSuffix } =
    content;

  return {
    isPromoActive: true,
    headline,
    tagline,
    image: {
      ...image,
      url: urlFor(image.image).width(HERO_IMAGE_WIDTH).url(),
    },
    cta: callToAction,
    duration,
    pricing:
      variation == 'price'
        ? {
            price,
            priceOverline,
            priceSubtext,
            priceSuffix,
          }
        : undefined,
    sash,
    variation,
  };
};

const getPrimaryDefaultData = (primaryDefault: PrimaryDefault) => {
  const { callToAction, image, headline, tagline } = primaryDefault;

  return {
    isPromoActive: false,
    headline,
    tagline,
    image: {
      ...image,
      url: urlFor(image.image).width(HERO_IMAGE_WIDTH).url(),
    },
    cta: callToAction,
    duration: undefined,
    pricing: undefined,
    sash: undefined,
    variation: undefined,
  };
};

export const getPrimaryHeroData = (
  primaryPromo: PrimaryPromo,
  primaryDefault: PrimaryDefault,
) => {
  const isPromoActive = isCurrentlyWithinDateRangeUTC(
    primaryPromo.duration.start.utc,
    primaryPromo.duration.end.utc,
  );

  return isPromoActive
    ? getPrimaryPromoData(primaryPromo)
    : getPrimaryDefaultData(primaryDefault);
};
